import axios from 'axios'
import { API_URL } from '@/lib/urls'
import { HEADERS } from '@/constants'
import Qs from 'qs'
import { env } from '@/lib/runtimeEnv'
export const querySerializationOptions = {
  arrayFormat: 'brackets',
  skipNulls: true,
}

const VERSION = env.VITE_TAG_NAME as string | undefined

const http = () => {
  const headers: any = {
    Accepts: 'application/json',
  }

  const accessToken = new URLSearchParams(window.location.search).get(
    'accessToken'
  )
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  if (VERSION) {
    headers[HEADERS.SPA_VERSION] = VERSION
  }

  const config = {
    baseURL: API_URL,
    timeout: 60000,
    headers,
    withCredentials: true,
    withXSRFToken: true,
    paramsSerializer: (params: any) => {
      return Qs.stringify(params, querySerializationOptions)
    },
  }

  const instance = axios.create(config)

  instance.interceptors.request.use(reqConfig => {
    let url = reqConfig.url
    if (url && !url.startsWith('http')) {
      if (!url.startsWith('/')) {
        url = `/${url}`
      }
      if (!url.startsWith('/v4/')) {
        url = `/v4${url}`
      }
      reqConfig.url = url
    }
    return reqConfig
  })

  return instance
}

export default http()
